"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderThumb = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _SliderMixin = require("../../mixins/components/SliderMixin");
/**
 * @since 6.12.0
 */
var SliderThumb = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "SliderThumb",
  componentId: "c11n-8-107-0__sc-1bk0m5x-0"
})(["", ""], _SliderMixin.SliderThumbMixin);
exports.SliderThumb = SliderThumb;
SliderThumb.displayName = 'SliderThumb';

/** @component */